<span nz-tooltip [nzTooltipTitle]="tooltipTitle">
  <nz-skeleton [nzAvatar]="avatar" [nzActive]="animated" [nzParagraph]="{ rows: rows }"></nz-skeleton>
</span>